import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';

const setProgress = (state, payload) =>
{
    const {progress} = state;
    const {module, slide, finished} = payload;

    if (!progress.hasOwnProperty(module)) { return; }

    if (slide)
    {
        progress[module].slide = slide;
    }
    if (finished)
    {
        progress[module].finished = finished;
    }
};

const setSlideState = (state, payload) =>
{
    const {slideStates} = state;
    const {module, namespace, slide} = payload;
    let {value} = payload;

    if (typeof value === 'object')
    {
        value = cloneDeep(value);
    }

    if (!slideStates.hasOwnProperty(module)) { return; }

    const moduleStates = slideStates[module];
    const slideState = {
        ...(moduleStates[slide] || {}),
        [namespace]: value
    };

    Vue.set(moduleStates, slide, slideState);
};

const offerTutorial = (state) =>
{
    state.tutorialOffered = true;
};

const finishModule = (state, module) =>
{
    if (state.progress[module])
    {
        state.progress[module].finished = true;
    }
};

export default {
    setProgress,
    setSlideState,
    offerTutorial,
    finishModule
};
